import React, { useEffect, useState } from "react";
import {
  Grid,
  CssBaseline,
  Paper,
  Box,
  Typography,
  Button,
} from "@mui/material";
import OtpLogin from "./OtpLogin";
import UsernamePasswordLogin from "./UsernamePasswordLogin";
import { LOGIN, NO_ACCOUNT_MESSAGE, SIGN_UP } from "../../constants/string";
import { useAuth } from "../../contexts/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import LOGO from "./../../assets/LoginLogo.png";
import { SIGNUP } from "../../constants/paths";
import theme from "../../CustomTheme";

const Login = () => {
  const location = useLocation();
  const {number, dialCode} = location.state || {};
  const [isUsingOtp, setIsUsingOtp] = useState(true);
  const { token } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      navigate("/");
    }
  }, [token, navigate]);

  const toggleLoginMethod = () => {
    setIsUsingOtp(!isUsingOtp);
  };
  const handleSignUpNavigation = () => {
    navigate(SIGNUP);
  };

  return (
    <Grid container component="main" sx={{ height: "100vh" }}>
      <CssBaseline />
      <Grid
        item
        xs={false}
        sm={4}
        md={8}
        sx={{
          backgroundImage: `url(${require("../../assets/lockScreen.jpg")})`,
          backgroundRepeat: "no-repeat",
          backgroundColor: (t) =>
            t.palette.mode === "light"
              ? t.palette.grey[50]
              : t.palette.grey[900],
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
        }}
      />
      <Grid item xs={12} sm={8} md={4} component={Paper} elevation={6} square>
        <Box
          sx={{
            my: 10,
            mx: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: 4,
          }}
        >
          <img src={LOGO} alt="Logo" style={{ width: "45%" }} />

          <Box sx={{ marginTop: 5 }}>
            <Typography component="h1" variant="h5" sx={{ marginBottom: 3 }}>
              {LOGIN}
            </Typography>
            {isUsingOtp ? <OtpLogin phoneNo = {number} dialCode = {dialCode}/> : <UsernamePasswordLogin />}
            <Button
              onClick={toggleLoginMethod}
              variant="text"
              sx={{
                width: "100%",
                mt: 2,
                textTransform: "none",
                textDecoration: "underline",
                "&:focus": {
                  textDecoration: "underline",
                },
                "&:active": {
                  textDecoration: "underline",
                },
              }}
            >
              {isUsingOtp
                ? "Use Username and Password"
                : "Use Mobile Number and OTP"}
            </Button>

            <Typography
              variant="body2"
              sx={{
                mt: 2,
                textAlign: "center",
                fontSize: "0.9rem",
                color: "textSecondary",
              }}
            >
              <Typography variant="body1" sx={{ fontSize: "14.5px" }}>
                {`${NO_ACCOUNT_MESSAGE} `}
                <Typography
                  component="span"
                  onClick={handleSignUpNavigation}
                  sx={{
                    textDecoration: theme.typography.decoration.textDecoration,
                    cursor: "pointer",
                    color: "#551A8B",
                    fontSize: "14.5px",
                  }}
                >
                  {SIGN_UP}
                </Typography>
              </Typography>
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Login;
